import { render, staticRenderFns } from "./result-group.vue?vue&type=template&id=20a5c8c1&scoped=true"
import script from "./result-group.vue?vue&type=script&lang=js"
export * from "./result-group.vue?vue&type=script&lang=js"
import style0 from "./result-group.vue?vue&type=style&index=0&id=20a5c8c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5c8c1",
  null
  
)

export default component.exports